import {
  ComponentHeader,
  ComponentHeaderProps,
} from "design-system/components/primitives/component-header/component-header";
import {
  PersonTease,
  PersonTeaseDisplayOptions,
  PersonTeaseProps,
} from "design-system/components/primitives/person-tease/person-tease";
import cn from "clsx";

export interface PeopleListingProps extends PersonTeaseDisplayOptions {
  header?: ComponentHeaderProps;
  people: Array<PersonTeaseProps>;
  HeadingLevel?: "h2" | "h3";
  HeadingLevelTease?: "h2" | "h3" | "h4";
}

/**
 * ## See it in use on...
 * - A [detail page](/story/example-pages-detail-pages-people-listing--story)
 * - A [landing page](/story/example-pages-landing-pages-people-listing--story)
 */
export function PeopleListing({
  header,
  align = "full",
  people,
  hideBio,
  hidePhone,
  hideSocial,
  emailVariant = "icon",
  HeadingLevel = "h2",
  HeadingLevelTease = "h3",
}: PeopleListingProps) {
  const alignClass = cn("hbs-people-listing", `hbs-global-align-${align}`);
  const listingClass = cn(
    "hbs-people-listing__list",
    hideBio
      ? `hbs-people-listing__header--no-bio`
      : `hbs-people-listing__header--bio`,
  );

  return (
    <section className={alignClass}>
      {header && <ComponentHeader {...header} HeadingLevel={HeadingLevel} />}
      {/* <div className={alignClass}> */}
      <ul className={listingClass}>
        {people.map((person, i) => (
          <PersonTease
            key={i}
            hideBio={hideBio}
            hidePhone={hidePhone}
            hideSocial={hideSocial}
            emailVariant={emailVariant}
            {...person}
            align={align}
            TeaseItem="li"
            HeadingLevel={HeadingLevelTease}
          />
        ))}
        {/* </div> */}
      </ul>
    </section>
  );
}
